const HSessionStore = {
    remove(key) {
        try {
            window.sessionStorage.removeItem(key);
        } catch (e) {
            console.warn("Browser doesn't support session storage");
        }
    },
    put(key, value) {
        try {
            window.sessionStorage.setItem(key, JSON.stringify(value));
        } catch (e) {
            console.warn("Browser doesn't support session storage");
        }
    },
    get(key) {
        try {
            const value = window.sessionStorage.getItem(key);
            if (value) {
                return JSON.parse(value);
            }
        } catch (e) {
            console.warn("Browser doesn't support session storage");
        }
    }
};

if (typeof window !== "undefined") {
    window.HSessionStore = HSessionStore;
}